import React from "react";
import "./styles.css";
import Forecast from "./Forecast";

export default function App() {
  return (
    <div className="App">
      <div id="weather" className="weather-box">
        <Forecast defaultCity="Toronto" />
      </div>
      <p className="git-link">
        {" "}
        <a href="https://github.com/green-nisaba/my-app">Open-source code</a> by
        AE
      </p>
    </div>
  );
}
